<div class="container md-my-5 my-2">
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="card shadow row">
        <div class="card-header bg-danger text-white">
          <h3 class="card-title text-center align-items-center mt-1">Reach Us</h3>
        </div>
       <div class="row">
         <div class="card-body col-md-6">
           <div class="text-center mb-4">
             <!--            <img src="./assets/images/SmartDukaan_Logo_Transparent.png" style="width: 200px;" loading="lazy">-->
             <h3 class="fw-bold text-center  mt-2" style="color:#d3181f">New Spice Solutions Private Limited</h3>
           </div>

           <!-- Contact Information Section -->
           <div class="row mb-4">
             <div class="col-md-6">
               <div class="card h-100">
                 <div class="card-body">
                   <h5 class="card-title text-danger"><i class="fas fa-map-marker-alt"></i> Address</h5>
                   <p class="card-text">
                     Priska Tower, 2nd Floor, C-56/45,C Block,<br>
                     Industrial Area Phase 2, Sector 62, <br>Noida - 201309 (UP),
                     Uttar Pradesh, India.<br>
                   </p>
                 </div>
               </div>
             </div>
             <div class="col-md-6">
               <div class="card h-100">
                 <div class="card-body">
                   <h5 class="card-title text-danger"><i class="pi pi-phone" style="font-size: 1.25rem"></i> Contact Number</h5>
                   <p class="card-text">
                     <a href="tel:18002700273" class="text-decoration-none">1800 2700 273</a>
                   </p>
                 </div>
               </div>
             </div>
           </div>

           <div class="row mb-4">
             <div class="col-md-6">
               <div class="card h-100">
                 <div class="card-body">
                   <h5 class="card-title text-primary"><i class="fas fa-envelope"></i> E-Mail ID</h5>
                   <p class="card-text">
                     <a href="mailto:care&#64;smartdukaan.com" class="text-decoration-none">care&#64;smartdukaan.com</a>
                   </p>
                 </div>
               </div>
             </div>
             <div class="col-md-6">
               <div class="card h-100">
                 <div class="card-body">
                   <h5 class="card-title text-primary"><i class="fas fa-globe"></i> Website</h5>
                   <p class="card-text">
                     <a href="https://www.smartdukaan.com" target="_blank" class="text-decoration-none">www.smartdukaan.com</a>
                   </p>
                 </div>
               </div>
             </div>
           </div>
         </div>
        <div class="card col-md-6 col-12 ">
          <div class="card-header text-black ">
            <h5 class="card-title text-center">Connect With Us</h5>
          </div>
        <div class="card-body md-ms-0 ms-3">
          <form [formGroup]="contactForm" (ngSubmit)="sendMessage()">
            <div class="mb-3">
              <label for="name" class="form-label">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Enter your name" pInputText>
              <div *ngIf="contactForm.get('name').invalid && contactForm.get('name').touched" class="text-danger">
                Name is required.
              </div>
            </div>

            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input type="email" class="form-control" formControlName="email" id="email" placeholder="Enter your email" pInputText>
              <div *ngIf="contactForm.get('email').invalid && contactForm.get('email').touched" class="text-danger">
                <div *ngIf="contactForm.get('email').errors.required">
                  Email is required.
                </div>
                <div *ngIf="contactForm.get('email').errors.email">
                  Email must be a valid email address.
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label for="mobile" class="form-label">Phone Number</label>
              <input type="tel" class="form-control" formControlName="mobile" id="mobile" placeholder="Enter your phone number" pInputText>
              <div *ngIf="contactForm.get('mobile').invalid && contactForm.get('mobile').touched" class="text-danger">
                <div *ngIf="contactForm.get('mobile').errors.required">
                  Phone number is required.
                </div>
                <div *ngIf="contactForm.get('mobile').errors.pattern">
                  Phone number must be 10 digits.
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label for="message" class="form-label">Message</label>
              <textarea class="form-control" formControlName="message" id="message" rows="4" placeholder="Enter your message" pInputTextarea></textarea>
              <div *ngIf="contactForm.get('message').invalid && contactForm.get('message').touched" class="text-danger">
                Message is required.
              </div>
            </div>

            <div class="text-center">
              <button type="submit" class="btn btn-danger" pButton label="Submit" [disabled]="contactForm.invalid"></button>
            </div>
          </form>
        </div>
        </div>
       </div>
      </div>
    </div>
    <div class="alert alert-info text-center mt-4 mb-5 mb-md-0">
      <i class="fas fa-info-circle"></i>
      <strong>Note:</strong> Need help? Our Customer Care team is here for you 24/7 — anytime, any day to assist you.
    </div>
  </div>
</div>
